document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');

  if (header) {
    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
      if (scrollTop === 0) {
        document.body.classList.remove('scroll-up', 'scroll-down');
      } else if ((scrollTop + 5) < lastScrollTop) {
        document.body.classList.add('scroll-up');
        document.body.classList.remove('scroll-down');
      } else if (scrollTop > lastScrollTop && scrollTop > 60) {
        document.body.classList.add('scroll-down');
        document.body.classList.remove('scroll-up');
      }
      lastScrollTop = scrollTop;
    });
  }
});
